export default __webpack_public_path__ + "static/media/ag_11.e21c782e.wav";